var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaceSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3999 28C16.3999 28 19.3999 32 24.3999 32C29.3999 32 32.3999 28 32.3999 28M30.3999 18H30.4199M18.3999 18H18.4199M44.3999 24C44.3999 35.0457 35.4456 44 24.3999 44C13.3542 44 4.3999 35.0457 4.3999 24C4.3999 12.9543 13.3542 4 24.3999 4C35.4456 4 44.3999 12.9543 44.3999 24ZM31.3999 18C31.3999 18.5523 30.9522 19 30.3999 19C29.8476 19 29.3999 18.5523 29.3999 18C29.3999 17.4477 29.8476 17 30.3999 17C30.9522 17 31.3999 17.4477 31.3999 18ZM19.3999 18C19.3999 18.5523 18.9522 19 18.3999 19C17.8476 19 17.3999 18.5523 17.3999 18C17.3999 17.4477 17.8476 17 18.3999 17C18.9522 17 19.3999 17.4477 19.3999 18Z",
    stroke: "#83F279",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceSmile);
export default __webpack_public_path__ + "static/media/face-smile.e97a7fb9ea36e77ece97f9e9d16a5fd0.svg";
export { ForwardRef as ReactComponent };